import { API, BASE_URLS } from "../../../api";
import { setCardOfferDetails, setShowOfferEngine, setUpiOfferDetails } from "../../../redux/offerEngine";

export function getEasebuzzOffers(params) {
  return async function (dispatch) {
    try {
      const [cardRes, upiRes] = await Promise.all([
        API.get(
          `${BASE_URLS.ACQUIRER_OFFER}/${params?.accountGid}?paymentMode=card&amount=${params?.amount || 0}`,
        ),
        API.get(
          `${BASE_URLS.ACQUIRER_OFFER}/${params?.accountGid}?paymentMode=upi&amount=${params?.amount || 0}`,
        ),
      ]);

      const cardEntity = cardRes?.data?.entity;
      const upiEntity = upiRes?.data?.entity;

      if(cardEntity?.length > 0 || upiEntity?.length > 0) {
        dispatch(setShowOfferEngine(true));
      };

      dispatch(setCardOfferDetails(cardEntity));
      dispatch(setUpiOfferDetails(upiEntity));

    } catch (e) {
      // handle error
      console.error(e);
    }
  };
}